/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
// document.addEventListener('product:added', function(event) {
//    var variant = event.detail.variant; // Get the variant that was added
//    var quantity = event.detail.quantity; // Get the quantity that was added
//    var price = event.detail.price;
//      pintrk('track', 'addtocart',{value: price ||variant.price,currency: Shopify.currency.active, order_quantity: quantity});
//  });

// jQuery('#inbed-size-chart-unit-toggle a').on("click", '[rel="toggle-units"]', function(e) {
//         var a = t(this).attr("data-unit");
//         t(a);
//         return t(this).closest("li").addClass("current").siblings().removeClass("current"),
//         "cm" == a ? (r.find(".size-dimensions-cm").attr("data-state", "open"),
//         r.find(".size-dimensions-in").attr("data-state", "closed")) : (r.find(".size-dimensions-in").attr("data-state", "open"),
//         r.find(".size-dimensions-cm").attr("data-state", "closed")),
//         !1
//     });
// jQuery('a').on("click", '[rel="size-chart-tab"]', function(e) {
//         var a = t(this).attr("href")
//           , i = t(a);
//         return t(this).closest("li").addClass("current").siblings().removeClass("current"),
//         i.length > 0 && (r.find('.tab-content[data-state="open"]').attr("data-state", "closed"),
//         i.attr("data-state", "open")),
//         !1
//     });

// function waitForElement(selector) {
//   return new Promise(function(resolve, reject) {
//     var element = document.querySelector(selector);

//     if(element) {
//       resolve(element);
//       return;
//     }

//     var observer = new MutationObserver(function(mutations) {
//       mutations.forEach(function(mutation) {
//         var nodes = Array.from(mutation.addedNodes);
//         for(var node of nodes) {
//           if(node.matches && node.matches(selector)) {
//             observer.disconnect();
//             resolve(node);
//             return;
//           }
//         };
//       });
//     });

//     observer.observe(document.documentElement, { childList: true, subtree: true });
//   });
// }
// waitForElement(".snpt-wdgt--ppg").then(function(element) {
//   console.log("snappt Added",element);

// });
// waitForElement(".snpt_widget--product_page_gallery").then(function(element) {
//   console.log("header Added",element);
// element.classList.add('ProductList--carousel')

// let header_container = element.childNodes;
//   header_container[1].classList.add('Container','SectionHeader');

// let header_text = header_container[1].childNodes;
//   header_text[1].classList.add('SectionHeader__Heading','Heading','u-h3');

// });
// waitForElement('#create_customer').then(function(element){
// console.log('Registration Form',element);
//   var $returnTo = $('<input type="hidden" name="return_to" value="/account" />');
//      $returnTo.insertBefore($('#create_customer button[type="submit"]')); // add return_to input
// });

// waitForElement('#g-recaptcha').then(function(element){
// console.log('Challenge',element);
//   var $returnTo = $('<input type="hidden" name="return_to" value="/account" />');
//           $returnTo.insertBefore($('.shopify-challenge__container input[type="submit"]'));
// });



// // Removing internal links (SEO directive)
// navLinkFn = function(e) {
//   e.preventDefault();
//   window.location.href = $(this).attr('data-url');
//   //console.log($(this).attr('data-url'));
// }

// var navLinks = document.getElementsByClassName('link-nav');
// for (var i=0; i < navLinks.length; i++) {
//   navLinks.item(i).onclick = navLinkFn;
// }

// // Product page image scroll fix for mobile
// (function() {
//   var touchingCarousel = false,
//       touchStartCoords;

//   document.body.addEventListener('touchstart', function(e) {
//     if (e.target.closest('.flickity-slider')) {
//       touchingCarousel = true;
//     } else {
//       touchingCarousel = false;
//       return;
//     }

//     touchStartCoords = {
//       x: e.touches[0].pageX,
//       y: e.touches[0].pageY
//     }
//   });

//   document.body.addEventListener('touchmove', function(e) {
//     if (!(touchingCarousel && e.cancelable)) {
//       return;
//     }

//     var moveVector = {
//       x: e.touches[0].pageX - touchStartCoords.x,
//       y: e.touches[0].pageY - touchStartCoords.y
//     };

//     if (Math.abs(moveVector.x) > 7)
//       e.preventDefault()

//       }, {passive: false});
// })();


// ALT PAYMENTS MODALS ON HOVER  -- PRODUCT PAGE

function docReady(fn) {
    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
        // call on next available tick
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}    

docReady(function() {
  if(screen.width > 600){

  var afterpay_link = document.querySelector('u.afterpay-link-inner');
  var afterpay_logo = document.querySelector('.alternate-payments .afterpay-logo');
  var klarna_link = document.querySelector('div.Klarna > a');
 var zip_link = document.querySelector('.alternate-payments .zip-logo');
 var zip_img = document.getElementById('shopify-zip-prod-widget');
// Alternate messaging Modals on Hover

var delay = function (elem, callback) {
    var timeout = null;
    elem.onmouseover = function() {
        // Set timeout to be a timer which will invoke callback after x ms
        timeout = setTimeout(callback, 800);
    };

    elem.onmouseout = function() {
        // Clear any timers set to timeout
        clearTimeout(timeout);
    }
};

delay(afterpay_logo, function() {
    afterpay_link.click();
});

delay(klarna_link, function() {
    klarna_link.click();
});


delay(zip_img, function() {
    zip_img.click();
});
 
  }
});

// Internal link removal
navLinkRemoval = function(e) {
  e.preventDefault();
  window.location.href = $(this).attr('data-url');
  //console.log($(this).attr('data-url'));
}

var navLinks = document.getElementsByClassName('link-nav');
for (var i=0; i < navLinks.length; i++) {
  navLinks.item(i).onclick = navLinkRemoval;
}